/** Progress toasts (customToast) live in their own Toaster, above the stack of normal toasts. */
export const PROGRESS_TOASTER_ID = "progress";
